import { styled, ToggleButtonGroup } from '@mui/material';

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  border: '1px solid rgba(0, 0, 0, 0.12)',
  borderRadius: '6px',
  backgroundColor: 'white',
  padding: 0,
  gap: 0,
  '& .MuiToggleButton-root': {
    border: 'none',
    borderRadius: 0,
    padding: '6px 12px',
    minWidth: '40px',
    color: theme.palette.text.secondary,
    transition: 'all 0.2s ease-in-out',
    '&:first-of-type': {
      borderTopLeftRadius: '6px',
      borderBottomLeftRadius: '6px',
    },
    '&:last-of-type': {
      borderTopRightRadius: '6px',
      borderBottomRightRadius: '6px',
    },
    '&:not(:last-of-type)': {
      borderRight: '1px solid rgba(0, 0, 0, 0.12)',
    },
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
      color: theme.palette.text.primary,
    },
    '&.Mui-selected': {
      backgroundColor: 'rgba(25, 118, 210, 0.08)',
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: 'rgba(25, 118, 210, 0.12)',
      },
    },
  },
}));

